import {
  Box,
  Button,
  Divider,
  CircularProgress,
  MobileStepper,
  Container,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import TreffasStyle from "src/utils/TreffasStyle";
import DateAndTime from "./DateAndTime";
import Information from "./Information";
import Success from "./Success";
import { getLayoutMaxWidth } from "src/theme/layout";
import TreffasButton from "src/components/TreffasButton";

const RenderBooking = ({
  handleSubmit,
  onSubmit,
  maxSteps,
  handleBack,
  validateOnNext,
  isProcess,
  packagePrice,
  submitButtonRef,
  errors,
  control,
  setSelectedTimezone,
  selectedTimezone,
  sessionList,
  selectedSessionTime,
  setSessionSelectedTime,
  setSessionList,
  selectedOffer,
  setBlockTimeOnSelectedDate,
  appForThisOffer,
  blockTimeOnSelectedDate,
  selectedDate,
  setSelectedDate,
  setError,
  clearErrors,
  activeStep,
  calendarMaxDate,
  userDateFormat,
  userTimeFormat,
  userMinimumBookingNotice,
  nextButtonRef,
  bookingInfo,
  setValue,
  coachDetails,
  getValues,
  overFlowTimeToRender,
  setOverFlowTimeToRender,
  underFlowTimeToRender,
  setUnderFlowTimeToRender,
  isUseTimeRecord,
  setIsUseTimeRecord,
  timeRecords,
  setTimeRecords,
  allUpcommingAppt,
  setAllUpcommingAppt,
}) => {
  const { t } = useTranslation();

  const themes = useTheme();

  const stepperGuideLength = [1, 2];

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box>
        {activeStep === 0 && (
          <DateAndTime
            errors={errors}
            setSelectedTimezone={setSelectedTimezone}
            selectedTimezone={selectedTimezone}
            sessionList={sessionList}
            selectedSessionTime={selectedSessionTime}
            setSessionSelectedTime={setSessionSelectedTime}
            selectedOffer={selectedOffer}
            setSessionList={setSessionList}
            setBlockTimeOnSelectedDate={setBlockTimeOnSelectedDate}
            appForThisOffer={appForThisOffer}
            blockTimeOnSelectedDate={blockTimeOnSelectedDate}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setError={setError}
            clearErrors={clearErrors}
            nextButtonRef={nextButtonRef}
            calendarMaxDate={calendarMaxDate}
            userDateFormat={userDateFormat}
            userTimeFormat={userTimeFormat}
            userMinimumBookingNotice={userMinimumBookingNotice}
            stepperGuideLength={stepperGuideLength}
            bookingInfo={bookingInfo}
            overFlowTimeToRender={overFlowTimeToRender}
            setOverFlowTimeToRender={setOverFlowTimeToRender}
            underFlowTimeToRender={underFlowTimeToRender}
            setUnderFlowTimeToRender={setUnderFlowTimeToRender}
            isUseTimeRecord={isUseTimeRecord}
            setIsUseTimeRecord={setIsUseTimeRecord}
            timeRecords={timeRecords}
            setTimeRecords={setTimeRecords}
            coachDetails={coachDetails}
            allUpcommingAppt={allUpcommingAppt}
            setAllUpcommingAppt={setAllUpcommingAppt}
          />
        )}

        <Container
          maxWidth={false}
          sx={{
             p: "0px !important" ,
            maxWidth: (theme) => getLayoutMaxWidth(theme, activeStep === 0 ? "bp" : "ntc"),
            width: "100%",
          }}
        >
          <Box
            sx={{
              minHeight:
                activeStep === 0 || activeStep === 4
                  ? "100%"
                  : "calc(90vh - 200px)",
            }}
          >
            {activeStep === 1 && (
              <Information
                errors={errors}
                control={control}
                selectedOffer={selectedOffer}
                clearErrors={clearErrors}
                stepperGuideLength={stepperGuideLength}
                isProcess={isProcess}
                submitButtonRef={submitButtonRef}
                bookingInfo={bookingInfo}
                setValue={setValue}
              />
            )}
          </Box>

          {activeStep === 4 && (
            <Success
              selectedSessionTime={selectedSessionTime}
              selectedOffer={selectedOffer}
              coachDetails={coachDetails}
              getValues={getValues}
            />
          )}

          {activeStep !== 4 && (
            <Box
              sx={{
                mt: activeStep === 0 ? "50px" : "0px",
                display: "none",
              }}
            >
              {activeStep !== 0 && (
                <Box
                  sx={{
                    my: "24px",
                  }}
                >
                  <Divider />
                </Box>
              )}

              <Box
                sx={{
                  my: "24px",
                }}
              >
                <MobileStepper
                  steps={maxSteps}
                  position="static"
                  activeStep={activeStep}
                  backButton={
                    <TreffasButton
                      variant="secondary"
                      size="lg"
                      disabled={activeStep === 0}
                      onClick={() => {
                        handleBack();
                      }}
                      sx={{
                        [themes.breakpoints.up("md")]: {
                          borderRadius: "12px",
                          fontSize: "14px",
                          minWidth: "100px",
                        },
                        opacity: activeStep === 0 ? 0 : 1,
                      }}
                    >
                      {t("booking.button.back")}
                    </TreffasButton>
                  }
                  nextButton={
                    <>
                      {activeStep !== maxSteps - 1 && (
                        <TreffasButton
                          variant="primary"
                          size="lg"
                          onClick={validateOnNext}
                          sx={{
                            display: activeStep === 0 ? "none" : "inline-flex",
                            [themes.breakpoints.up("md")]: {
                              borderRadius: "12px",
                              fontSize: "14px",
                              minWidth: "100px",
                            },
                          }}
                          type={"button"}
                          ref={nextButtonRef}
                          loading={isProcess}
                        >
                          {activeStep === 1
                            ? parseInt(packagePrice) < 1
                              ? t("booking.button.confirm")
                              : t("booking.button.next")
                            : t("booking.button.next")}
                        </TreffasButton>
                      )}

                      {activeStep === maxSteps - 1 && (
                        <TreffasButton
                          variant="primary"
                          size="lg"
                          sx={{
                            [themes.breakpoints.up("md")]: {
                              borderRadius: "12px",
                              minWidth: "100px",
                              fontSize: "14px",
                            },
                          }}
                          type={"submit"}
                          loading={isProcess}
                        >
                          {t(
                            "individual.booking.schedule.choose_schedule.button.schedule_event"
                          )}
                        </TreffasButton>
                      )}
                    </>
                  }
                  sx={{
                    "& .MuiMobileStepper-dots": {
                      display: "none",
                    },
                  }}
                />
              </Box>
            </Box>
          )}
        </Container>
      </Box>

      <input type="submit" style={{ display: "none" }} ref={submitButtonRef} />
    </form>
  );
};

export default RenderBooking;
